module.exports = __webpack_public_path__ + "img/vertical_1_1_9016.37e1190f.png";